export default "__VITE_ASSET__Cs49mp8r__"